import {action} from 'mobx';

import {AppModuleState} from "./models/app-module.state";
import {BaseMobxStore} from "../../infrastructure/mobx/base-mobx-store";
import {ODDS_TYPES} from "../components/odds/components/odds-consts";
import {LocaleDomainModel} from "../../domain/locale/models/locale/locale.domain-model";
import {AppModuleConfig} from "./app-config";
import {singleton} from "../../infrastructure/decorators/singleton";

@singleton
export class AppStore extends BaseMobxStore {
  state: AppModuleState;

  static injectables = [AppModuleConfig, AppModuleState];

  @action setDataInitialized(dataInitialized: Boolean = true) {
    this.state.dataInitialized = dataInitialized;
  }

  @action setSelectedOddsType(oddsType: ODDS_TYPES) {
    this.state.currentOddsType = oddsType;
  }

  setLocale(locale: LocaleDomainModel) {
    this.state.locale = locale;

    this.state.languageChangedCallbacks.forEach(callback => callback(locale));
  }

  setIsUserHoverAd(isUserHoverAd: Boolean) {
    this.state.isUserHoverAd = isUserHoverAd;
  }

  setShowOdds(showOdds: Boolean) {
    this.state.showOdds = showOdds;
  }

  setShowSecondaryOdds(showSecondaryOdds: Boolean) {
    this.state.showSecondaryOdds = showSecondaryOdds;
  }

  setEnableNotifications(enableNotifications: Boolean) {
    this.state.enableNotifications = enableNotifications;
  }

  registerCallbackToLanguageChange(callback) {
    this.state.languageChangedCallbacks.push(callback)
  }
}

